import { ProfessionIcon } from './profession-icon';

export const IconPlumber = () => (
  <ProfessionIcon bg="#E3F2FD">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <path
        d="M6 12h4v8a2 2 0 01-2 2h0a2 2 0 01-2-2v-8z"
        stroke="#2196F3"
        strokeWidth="1.8"
      />
      <path d="M10 12h6V8h-6v4z" stroke="#2196F3" strokeWidth="1.8" />
      <path
        d="M12 4v4"
        stroke="#2196F3"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M14 12h4v4a2 2 0 01-2 2h0a2 2 0 01-2-2v-4z"
        stroke="#2196F3"
        strokeWidth="1.8"
      />
    </svg>
  </ProfessionIcon>
);
